import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getIsFeatureEnabled } from "~/store/selectors/selector.configOptions";

export const RequireQuickBooksFeature = ({ children, redirectTo }) => {
  const hasQuickBooksFeature = useSelector((state) => getIsFeatureEnabled(state, "quickbooks_integration"));

  return hasQuickBooksFeature ? children : <Navigate to={redirectTo} />;
};

RequireQuickBooksFeature.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireQuickBooksFeature.defaultProps = {
  redirectTo: "/not-found",
};
